var teknion = teknion || {};
teknion.internal_luumca_order_cancellations = (function(base_url, app_id, company_code) {
  var app_url = base_url + '/internal/luumca';

  var debug = function() {
    console.log('teknion.internal_luumca_order_cancellations');
    console.log(app_url);
    console.log(app_id);
    console.log(company_code);
  };

  var index = function(customer_id) {
    return $.ajax({
      type: 'GET',
      url: app_url + '/get_my_cancellations',
      data: {
        customer_id: customer_id,
        company_code: company_code,
        appid: app_id,
      },
      crossDomain: true,
      dataType: 'JSON',
      contentType: false,
    });
  };

  var get = function(customer_id, id) {
    return $.ajax({
      type: 'GET',
      url: app_url + '/cancellation_details',
      crossDomain: true,
      data: {
        id: id,
        customer_id: customer_id,
        company_code: company_code,
        appid: app_id,
      },
    });
  };

  var create = function(formData) {
    // append app ID
    formData.append("appid", app_id);
    formData.append("company_code", company_code);
    return $.ajax({
      type: 'POST',
      url: app_url +'/order_cancellations',
      crossDomain: true,
      data: formData,
      contentType: false,
      processData: false,
    });
  };

  return {
    // debug: debug, // only uncomment for debugging purposes, ensure commented out in production
    index: index,
    get: get,
    create: create,
  };

})(teknion.base_url, teknion.app_id, teknion.company_code);